import { configEnv } from '@/shared/config-env';

export const validClientParams = {
  SYNERGY_FRIENDS: configEnv.VUE_APP_SF_CLIENT,
  SYNERGY_PEOPLE: configEnv.VUE_APP_SP_CLIENT,
  MOI_CAPITAL: configEnv.VUE_APP_MOI_CLIENT,
  MOSAP: configEnv.VUE_APP_MS_CLIENT,

};

export const validClientUrls = {
  SYNERGY_FRIENDS: configEnv.VUE_APP_SF_URL,
  SYNERGY_PEOPLE: configEnv.VUE_APP_SP_URL,
  MOI_CAPITAL: configEnv.VUE_APP_MC_URL,
  MOSAP: configEnv.VUE_APP_MS_URL,
};
